export class PhysicalInventoryListItem
{
    public id: string = '';
    public date: string = '';
    public name: string = '';
    public status: string = '';
    public totalValue?: number = undefined;
}